import React from 'react'
import {useTable, Column, Row, ColumnInstance, TableState} from 'react-table'
import {CustomHeaderColumn} from './CustomHeaderColumn'
import {CustomRow} from './CustomRow'

type Props<T extends object> = {
  columns: ReadonlyArray<Column<T>>
  data: T[]
  borderedHeader?: Boolean
  initialState?: Partial<TableState<T>>
}

export const CustomTable = <T extends object>({
  columns,
  data,
  borderedHeader = false,
  initialState,
}: Props<T>) => {
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
    initialState: initialState,
  })

  const border = 'bg-gray-100 border border-1 border-primary text-primary-dark'

  return (
    <div className='table-responsive'>
      <table
        className='table align-middle table-row-dashed fs-5 gy-5 dataTable no-footer'
        {...getTableProps()}
      >
        <thead>
          <tr className={`text-start fw-bold gs-0 ${borderedHeader ? border : 'text-primary-dark'}`}>
            {headers.map(
              (column: ColumnInstance<T>) =>
                column.isVisible && <CustomHeaderColumn key={column.id} column={column} />
            )}
          </tr>
        </thead>
        <tbody className='text-gray fw-semibold' {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row: Row<T>, i) => {
              prepareRow(row)
              return <CustomRow row={row} key={`row-${i}-${row.id}`} />
            })
          ) : (
            <tr>
              <td colSpan={columns.length}>
                <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                  No se encontraron registros
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}
